export type ProductKey = 'SUPER_PREP' | 'SUPER_COACH' | 'TEACHER_APP';

export const PRODUCTS: { key: ProductKey; label: string }[] = [
  { key: 'SUPER_PREP', label: 'Super Prep' },
  { key: 'SUPER_COACH', label: 'Super Coach' },
  { key: 'TEACHER_APP', label: 'Teacher App' },
];

// Time window token for analytics endpoints.
// '6h'/'12h'/'24h' -> rolling hours; '2d'/'7d'/'30d'/'90d' -> days; 'all' -> all-time.
export type RangeValue = '6h' | '12h' | '24h' | '2d' | '7d' | '30d' | '90d' | 'all';

export const RANGE_OPTIONS: { value: RangeValue; label: string }[] = [
  { value: '6h', label: 'Last 6 hours' },
  { value: '12h', label: 'Last 12 hours' },
  { value: '24h', label: 'Last 24 hours' },
  { value: '2d', label: 'Last 2 days' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: 'all', label: 'All time' },
];

// Map a range token to the query-string the analytics endpoints understand.
export const RANGE_QUERY: Record<RangeValue, string> = {
  '6h': 'hours=6',
  '12h': 'hours=12',
  '24h': 'hours=24',
  '2d': 'days=2',
  '7d': 'days=7',
  '30d': 'days=30',
  '90d': 'days=90',
  'all': 'days=all',
};
